import React from 'react';
import { Link } from 'react-router-dom';
import HealthPill from '../HealthPill';
import { Panel } from './primitives';

// `dummy` / `dummyco` is the pre-2023 onboarding default on the BRP device row, not a make.
const PLACEHOLDER_MANUFACTURERS = new Set(['dummy', 'dummyco']);

export const manufacturerLabel = value => (!value || PLACEHOLDER_MANUFACTURERS.has(String(value).toLowerCase()) ? '—' : value);

const TYPE_LABEL = {
    bat: 'Battery',
    ev: 'EV',
    cs: 'Charging station',
    hvac: 'HVAC',
    si: 'Solar inverter',
    sm: 'Smart meter',
    other: 'Other',
};

export const typeLabel = value => (value ? TYPE_LABEL[value] ?? value : '—');

// The battery's members. Each links to its device page (info, health, alerts); a member with
// a gateway also links to its gateway page.
const DevicesTable = ({ battery, memberStatus }) => (
    <Panel icon="fa-microchip" title="Devices" right={`${battery.members.length} ${battery.members.length === 1 ? 'device' : 'devices'}`}>
        {battery.members.length === 0 ? (
            <p className="gw-empty">This battery has no devices.</p>
        ) : (
            <table className="vb-table vb-table--flush">
                <thead>
                    <tr>
                        <th>Device</th>
                        <th>Type</th>
                        <th>Manufacturer</th>
                        <th>Health</th>
                        <th>Gateway</th>
                    </tr>
                </thead>
                <tbody>
                    {battery.members.map(member => {
                        const gateway = memberStatus.gatewayByDevice.get(member.deviceId);
                        return (
                            <tr key={member.deviceId}>
                                <td className="vb-table__mono">
                                    <Link className="gw-link" to={`/vbatt-devices/${member.deviceId}`}>
                                        {member.deviceId}
                                    </Link>
                                </td>
                                <td>{typeLabel(member.type)}</td>
                                <td>{manufacturerLabel(member.manufacturer)}</td>
                                <td>
                                    <HealthPill status={member.healthStatus} />
                                </td>
                                <td>
                                    {!memberStatus.isReady ? (
                                        '…'
                                    ) : gateway ? (
                                        <Link className="gw-link" to={`/gateways/${member.deviceId}`}>
                                            Open gateway <i className="fa-solid fa-arrow-right" />
                                        </Link>
                                    ) : (
                                        '—'
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        )}
    </Panel>
);

export default DevicesTable;
